import type { EdgeId, GeneratedPacketData } from '@ipfabric/utils';
import type { PacketDetail } from 'components/DeviceView/deviceViewTypes';

export const getGeneratedPacketDetail = (
  fakeEdgeId: EdgeId,
  generatedPacketData: GeneratedPacketData,
): PacketDetail => {
  return {
    id: fakeEdgeId,
    packet: generatedPacketData.packet,
    showAnimation: true,
    sourceLabel: null,
    targetLabel: null,
    trafficScore: generatedPacketData.trafficScore,
  };
};
